$(document).ready(function() {

    $('.reviews-item__more a').click(function(e){
        e.preventDefault();
        let parent = $(this).closest('.reviews-item');
        parent.find('.reviews-item__full').fadeIn(300);
        parent.addClass('active');
    });

    // $('.reviews-leave .button').click(function(e){
    //     new Form($('#reviews_add'));
    // });
});